import type { TargetCriteria } from 'components/surveys/builder/surveyDraft'

export interface ReviewTargetCriteria {
  supplier_id?: number | null
  contract_id?: number | null
  contract_vehicle_id?: number | null
  agency_id?: number | null
}

const CRITERIA_KEYS: Array<[keyof TargetCriteria, keyof ReviewTargetCriteria]> = [
  ['targeted_supplier_id', 'supplier_id'],
  ['targeted_contract_id', 'contract_id'],
  ['targeted_contract_vehicle_id', 'contract_vehicle_id'],
  ['targeted_agency_id', 'agency_id']
]

const targetMatches = (target: TargetCriteria, review: ReviewTargetCriteria): boolean =>
  CRITERIA_KEYS.every(([targetKey, reviewKey]) => {
    const value = target[targetKey]
    return value == null || value === review[reviewKey]
  })

export const surveyTargetMismatch = (targets: TargetCriteria[], review: ReviewTargetCriteria): boolean => {
  if (targets.length === 0) return false
  return !targets.some((target) => targetMatches(target, review))
}
